import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import { Popover } from "antd";
import { useSelector } from "react-redux";
import dashboardRoutes from "../../nav";
import "./BottomNav.scss";

import homeIC from "common/assets/imgs/trangchu.png";
import chatbotIC from "common/assets/imgs/chatbot.png";
import userIC from "common/assets/imgs/canhan.png";
import notiIC from "common/assets/imgs/alert.png";
import menuIcon from "common/assets/imgs/menu.png";

import homeICSelected from "common/assets/imgs/trangchuhover.png";
import chatbotICSelected from "common/assets/imgs/chatbothover.png";
import userICSelected from "common/assets/imgs/canhanhover.png";
import notiICSelected from "common/assets/imgs/alerthover.png";
import menuIconSelected from "common/assets/imgs/menuhover.png";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { General } = useSelector((state) => state);
  const { Menu, ShowUC } = General || {};

  const [selectedKey, setSelectedKey] = useState("/home");
  const [lastNonChatbotKey, setLastNonChatbotKey] = useState("/home");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuGroups = useMemo(() => {
    if (!Menu || !Array.isArray(Menu)) return [];

    const groupsMap = Menu.reduce((acc, item) => {
      const routeConfig = dashboardRoutes.find((r) => r.path === item.URL);
      if (routeConfig && routeConfig.isUpdating && !ShowUC) {
        return acc;
      }

      // Ẩn menu nếu UC_DEV là true nhưng ShowUC là false
      if (item.UC_DEV && !ShowUC) {
        return acc;
      }

      const gName = item.group?.name || "Khác";
      const gSTT = item.group?.STT || 999;

      if (!acc[gName]) {
        acc[gName] = {
          label: gName,
          STT: gSTT,
          items: [],
        };
      }

      acc[gName].items.push({
        label: item.Name,
        path: item.URL,
        STT: parseInt(item.STT) || 0,
        icon: item.icon || "fa-circle-dot",
        isChild: !!item.Parent_Id?._id?.$oid || !!item.Parent_Id?._id,
      });

      return acc;
    }, {});

    return Object.values(groupsMap)
      .sort((a, b) => a.STT - b.STT)
      .map((group) => ({
        ...group,
        items: group.items.sort((a, b) => a.STT - b.STT),
      }));
  }, [Menu, ShowUC]);

  const mobileMenuContent = useMemo(() => {
    return (
      <div className="mobile-menu-popover">
        {menuGroups.map((group, gi) => (
          <div key={gi} className="mobile-menu-group">
            <div className="mobile-menu-group-label">{group.label}</div>
            {group.items.map((item, ii) => (
              <div
                key={ii}
                className={`mobile-menu-item ${
                  location.pathname === item.path ? "active" : ""
                } ${item.isChild ? "mobile-menu-item--child" : ""}`}
                onClick={() => {
                  setOpen(false);
                  navigate(item.path);
                }}
              >
                <i className={`fa ${item.icon} mr-2`} />
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }, [menuGroups, location.pathname, navigate]);

  const items = [
    { key: "/home", icon: homeIC, iconSelected: homeICSelected },
    {
      key: "/chatbot",
      icon: chatbotIC,
      iconSelected: chatbotICSelected,
      disabled: true,
    },
    {
      key: "/ca-nhan",
      icon: userIC,
      iconSelected: userICSelected,
    },
    { key: "/thong-bao", icon: notiIC, iconSelected: notiICSelected },
    {
      key: "/menu",
      icon: menuIcon,
      iconSelected: menuIconSelected,
      disabled: false,
    },
  ];

  const showChatbot = () => {
    document
      .getElementById("iframeContainer")
      ?.style.setProperty("display", "block");
    document
      .getElementById("myIframe")
      ?.style.setProperty("visibility", "visible");
  };

  const hideChatbot = () => {
    document
      .getElementById("iframeContainer")
      ?.style.setProperty("display", "none");
    document
      .getElementById("myIframe")
      ?.style.setProperty("visibility", "hidden");
  };

  const handleClick = (item) => {
    if (item.disabled) return;

    const key = item.key;

    if (key === "/chatbot") {
      if (selectedKey === "/chatbot") {
        setSelectedKey(lastNonChatbotKey);
        navigate(lastNonChatbotKey);
        hideChatbot();
      } else {
        setSelectedKey("/chatbot");
        showChatbot();
      }
    } else {
      setSelectedKey(key);
      setLastNonChatbotKey(key);
      hideChatbot();
      navigate(key === "/thong-bao" ? key : "/home");
    }
  };

  return (
    <div
      style={{
        ...styles.menuContainer,
        visibility: isMobile ? "visible" : "hidden",
      }}
    >
      {items.map((item) => {
        const isSelected = selectedKey === item.key;
        const isDisabled = item.disabled;
        const isMenu = item.key === "/menu";

        const iconElement = (
          <img
            src={isSelected ? item.iconSelected : item.icon}
            alt={item.key}
            style={styles.icon}
          />
        );

        return (
          <button
            key={item.key}
            onClick={() => !isMenu && handleClick(item)}
            style={{
              ...styles.button,
              opacity: isDisabled ? 0.4 : 1,
              cursor: isDisabled ? "not-allowed" : "pointer",
            }}
            disabled={isDisabled}
          >
            {isMenu ? (
              <Popover
                content={mobileMenuContent}
                trigger="click"
                placement="topRight"
                open={open}
                onOpenChange={(visible) => setOpen(visible)}
                overlayClassName="bottom-nav-popover"
              >
                <div onClick={(e) => e.stopPropagation()}>{iconElement}</div>
              </Popover>
            ) : (
              iconElement
            )}
          </button>
        );
      })}
    </div>
  );
};

const styles = {
  menuContainer: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    background: "#1a73e8",
    display: "flex",
    justifyContent: "space-around",
    padding: "24px 0",
    zIndex: 999,
    borderTop: "1px solid #eee",
  },
  button: {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
  },
  icon: {
    width: 20,
    height: 20,
  },
};

export default BottomNav;
